export default __webpack_public_path__ + "static/media/energy.d1e26f70.svg";